import * as React from "react";
import { forwardRef } from "react";
const SvgTooltipArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 18, viewBox: "0 0 9 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.41421 10.4142C0.633164 9.63316 0.633166 8.36683 1.41422 7.58579L9 1.18021e-06L9 18L1.41421 10.4142Z", fill: "#1A2023", fillOpacity: 0.8 }));
const ForwardRef = forwardRef(SvgTooltipArrow);
export { ForwardRef as ReactComponent };
